/** Hero / landing imagery — matches demo2 front images and homepage panels */
export const IMAGES = {
  grainHandling: '/assets/grain-handling.png',
  foodProcessing: '/assets/food-processing.png',
  warehousing: '/assets/warehousing.png',
  foodStorage: '/assets/food-storage.png',
  portServices: '/assets/port-services.png',
  consumer: '/assets/consumer.png',
  heroPanels: '/assets/hero-panels.png',
  heroFull: '/assets/hero-full.png',
  about: '/assets/headers/about.png',
  industries: '/assets/headers/industries.png',
  solutions: '/assets/headers/solutions.png',
  resources: '/assets/headers/resources.png',
  services: '/assets/headers/services.png',
  contact: '/assets/headers/contact.png',
  industrial: '/assets/headers/industrial.png',
  agricultural: '/assets/headers/agricultural.png',
}

/** Solution page headers — ChatGPT series from demo2 */
export const SOLUTION_IMAGES = {
  commercialPestControl: '/assets/headers/commercial-pest-control.png',
  rodentControl: '/assets/headers/rodent-control.png',
  antControl: '/assets/headers/ant-control.png',
  cockroachControl: '/assets/headers/cockroach-control.png',
  birdControl: '/assets/headers/bird-control.png',
  snakeControl: '/assets/headers/snake-control.png',
  wildlifeControl: '/assets/headers/wildlife-control.png',
}
